import type { Boundaries } from '@widgets/shared/types'
import { addPaddingsToBoundaries } from '@widgets/shared/utils/boundaries'
import { ref, watch } from '@/composition/vue/compositionApi'
import type { ClickToTextWidgetState } from '@/components/domain/services/forms/clickToText/types'

export const useClickToTextWidgetState = (resize: (boundaries: Boundaries) => void) => {
  const widgetState = ref<ClickToTextWidgetState>('minimized')

  const getBoundaries = (): Boundaries =>
    widgetState.value === 'minimized'
      ? addPaddingsToBoundaries({ width: 250, height: 60 }, { alignY: true })
      : addPaddingsToBoundaries({ width: 400, height: 580 })

  watch(
    widgetState,
    () => {
      const boundaries = getBoundaries()
      resize(boundaries)
    },
    { immediate: true },
  )

  return {
    widgetState,
  }
}
